import type { PaymentStatType, TenantPaymentStatDTO } from '../tenantBillingStat.types';

export class TenantPaymentStatDTOModel {
  private readonly _dto: TenantPaymentStatDTO;

  constructor(dto: TenantPaymentStatDTO) {
    this._dto = dto;
  }

  get originDTO(): TenantPaymentStatDTO {
    return this._dto;
  }

  get cost(): number {
    return this._dto.cost ?? 0;
  }

  get name(): string {
    return this._dto.name;
  }

  get type(): PaymentStatType {
    return this._dto.type;
  }

  get currencyUnit(): CurrencyUnit {
    return this._dto.currencyUnit;
  }

  get iconUrl(): string {
    return this._dto.iconUrl ?? '';
  }
}
